
import React, { Component } from 'react';
import {
    Col, InputGroup, Input, Tooltip,
    FormGroup, Label, InputGroupAddon, InputGroupText, Row
} from 'reactstrap';
import './fields.css';
import axios from "axios";
import logo from '../../Assets/Images/logo.png'
import user from '../../Assets/Images/user.png';
import cinema from '../../Assets/Images/cinemaLogo.jpg';
import event from '../../Assets/Images/EventPlanner.jpg'
import film from '../../Assets/Images/FilmAvater.jpg';
import ticket from "../../Assets/Images/ticket.jpg"
import cinemaHall from "../../Assets/Images/cinemaImage.jpg"
import eventHall from "../../Assets/Images/EventsAvater.jpg"
import avaterproduct from "../../Assets/Images/uploading2.png"
import String from "../../Assets/Localization/local.js"
// import car from '../../assets/Images/car.jpg'
import { API_ENDPOINT } from '../../AppConfig'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from 'react-redux-loading-bar'


import ReactImageFallback from "react-image-fallback";


class CustomInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGoing: true,
            imagePreviewUrl: null,
            fileSelected: null,
            previouslang: null,
            previousuri: null,
            tooltipOpen: false,

        }
        this.toolTiptoggle = this.toolTiptoggle.bind(this);
    }
    toolTiptoggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }
    InputhandleChange(e, input, type) {
        // const renum = /^[0-9]+$/;
        // const ch = String.fromCharCode(e.which);
        // const re = /^[أ-ي\s]*$/,
        const reEn = /^[a-zA-Z\s]*$/;
        if (type === "image") { }
        if (type === "maxLength") {
            if (e.target.value.length >= 5) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        if (type === "number") {
            if (!(e.which >= 48 && e.which <= 57)) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }

        }
        else if (type === 'float') {
            if (!((e.which >= 48 && e.which <= 57) || e.which === 46)) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        else if (type === "time") {
            if (!((e.which >= 48 && e.which <= 57) || e.key === ":")) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        else if (type === "ar") {
            if (!((e.which >= 1571 && e.which <= 1610) || e.which === 32 || e.which === 13)) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }

        }
        else if (type === 'num_Ar') {
            if (!((e.which >= 48 && e.which <= 57) || (e.which >= 1571 && e.which <= 1610)|| e.which===32)) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        else if (type === 'num_En') {
            if (!((e.which >= 48 && e.which <= 57) || (e.which >= 97 && e.which <= 122) || (e.which >= 65 && e.which <= 90)|| e.which===32)) {
                e.preventDefault();
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        else if (type === "en") {
            if (e.target.value[0] === ' ') {

            }
            else if (e.target.value === '' || reEn.test(e.target.value)) {
                input.onChange(e)
                this.setState({ object: e.target.value })
            }
        }
        else {
            input.onChange(e)
            this.setState({ object: e.target.value })
        }
    }

    handelOption(event, name, ) {

        let object = name.name
        object = object.split("_")
        if (object[0] === "carType") {
            this.props.selectoronChange(event.target.value, object[1])

        }
    }
    handleScroll = e => {
        console.log("reach Bottom handleScroll")
        let element = e.target
        // elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight()
        if (element.scrollHeight - element.scrollTop <= element.outerHeight ) {
            console.log("reach Bottom")
        //   this.setState({ spinner: true })
        //   this.page++
        //   this.fetch_lastconvusers(this.state.userID, this.state.image, this.state.name, this.state.active, true)
        }
    
      }

    fetchRequest(uri, lang) {
        let token = 'Bearer ' + this.props.token
        let url = `${API_ENDPOINT}` + uri
        axios.get(url, {
            headers: {
                'Authorization': token,
                "Accept-Language": lang
            }
        })
            .then(response => {
                const info = response.data.data;
                console.log("info",info)
                this.setState({ object: info, previousuri: uri }, () => {
                });
            }).catch(error => { })
    }
    handleChange(e, input) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            // input.onChange(file);
            input.onChange({ file: file, image: reader.result });
            this.setState({
                file: file,
                fileSelected: file.name,
                imagePreviewUrl: reader.result
            });
        }
        if (file) {
            let splitType = file.type.split('/');
            if (splitType[0] === 'image') {
                reader.readAsDataURL(file);
            }

        }
    }
    handleCheckChange = (e, id, flagName) => {
        if (e.target.name === "all") {
            this.Check(e.target.checked, flagName)
        } else {
            if (e.target.checked) {
                this.props.handlepush(id, flagName)
            }
            else {
                this.props.handleremove(id, flagName)
            }
        }

    }
    Check(check, name) {
        if (check) {
            this.state.object.map(elment => this.props.handlepush(elment.id, name))
        }
        else {
            this.props.handleremove("all", name)
        }
        var x = document.getElementsByClassName(name);
        for (let i = 0; i < x.length; i++) {
            x[i].checked = check;
        }
    }
    componentWillMount() {
        if (this.props.imagepreview) {
            let imageurl = API_ENDPOINT + this.props.imagepreview
            this.setState({ imagePreviewUrl: imageurl })
        }
        this.setState({ previouslang: this.props.lang })
        if (this.props.uri && this.props.uri !== undefined) {
            this.fetchRequest(this.props.uri, this.props.lang)
        }
        else {}
    }
    fn(input, name) {
        this.setState({ imagePreviewUrl: null, file: null })
        input.onChange({ name: name, fun: `delete` })
    }

    selectedColor = '#09c';
    gradientSettings = {
        opacity: false
    };
  
    render() {
        const { lang, placeholder, uploaded, section, child, object_name,
            input, name, options, type, icone, size, title, label,
            keyId, keyElement, optionTitle, filetype, maxLength, inputType, countryCode,
            meta: { touched, error }

        } = this.props


        const object = this.state.object
        // let { imagePreviewUrl, fileSelected } = this.state;
        // let $imagePreview = null;
        // if (imagePreviewUrl) {
        //     if (uploaded === "image") {
        //         $imagePreview = (<img src={imagePreviewUrl} style={{ width: "100px" }} alt="category" />);
        //     } else {
        //         $imagePreview = fileSelected
        //     }
        // }
        if (this.state.previouslang !== this.props.language && this.props.uri && this.props.uri !== undefined) {
            this.setState({ previouslang: this.props.language })
            this.fetchRequest(this.props.uri, this.props.language)
        }
        if (this.state.previousuri !== this.props.uri && this.props.uri !== undefined) {
            this.setState({ previousuri: this.props.uri })
            this.fetchRequest(this.props.uri, this.props.language)
        }
        return (

            // <div>
            <Col lg={size ? size.lg : "12"} md={size ? size.md : "12"} className="p-0 " > 
                {/* {section && <h4 style={{color:this.props.color}}>{lang === "ar" ? section.ar : section.en}</h4>} */}
                {/* {type && */}

                {type === "LABEL" && <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}>{label}</Label>}
                {type !== "LABEL" &&
                    <FormGroup style={{display:this.props.display?"none":""}}>
                        <div className="mx-3">
                            <InputGroup className={this.props.uploaded === 'user' ? 'centerImage' : ''}>
                                <Label className={lang === "en" ? "labelInput LeftAlign" : "labelInput RightAlign"}>{label}</Label>
                                {/* Radio Button Input */}
                                {(type === "radio") &&
                                    <div className="checkboxlabel">
                                        <div style={{ display: "inline-block", paddingTop: label ? "" : "1.2rem" }}>
                                            <Input  {...input} type={type}
                                                value={input.value ? (this.state.object ? this.state.object : input.value) : this.state.object} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }}
                                                name={object_name} />{' '}<span>{title}</span>
                                        </div>
                                    </div>
                                }
                                {(type === "checkbox") &&
                                    <div className="checkboxlabel">
                                        <div style={{ display: "inline-block", paddingTop: label ? "" : "1.2rem" }}>
                                            <Row>

                                                {object && object.map((element, index) => {
                                                    if (index === 0) {
                                                        return (
                                                            <div style={{ width: "100%", display: "inline-flex" }}>
                                                                <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>
                                                                    <input
                                                                        name={section}
                                                                        type={type}
                                                                        class={this.props.flag}
                                                                        flag={name}
                                                                        // accept={filetype}
                                                                        onChange={(e) => { this.handleCheckChange(e, "", this.props.flag) }}
                                                                    // onChange={event => this.handleCheckChange(name)}
                                                                    />{' '}<span>{title}</span>
                                                                </Col>
                                                                <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                                    <input
                                                                        // name={section}
                                                                        type={type}
                                                                        class={this.props.flag}
                                                                        flag={name}
                                                                        // accept={filetype}
                                                                        onChange={(e) => { this.handleCheckChange(e, element[keyId], this.props.flag) }}
                                                                    // onChange={event => this.handleCheckChange(name)}
                                                                    />{' '}<span>{element[keyElement]}</span>

                                                                </Col>
                                                            </div>

                                                        )

                                                    }
                                                    return (
                                                        <Col lg={size ? size.sub : "4"} md={size ? size.sub : "12"}>

                                                            <input
                                                                // name={section}
                                                                type={type}
                                                                class={this.props.flag}
                                                                // accept={filetype}
                                                                flag={name}
                                                                onChange={(e) => { this.handleCheckChange(e, element[keyId], this.props.flag) }}
                                                            // onChange={event => this.handleCheckChange(name)}
                                                            />{' '}<span>{element[keyElement]}</span>

                                                        </Col>
                                                    )

                                                })
                                                }
                                            </Row>



                                        </div>
                                    </div>
                                }


                                {/* select Box Input */}

                                {type === "select" &&
                                    (this.props.dropdownModal ?

                                        <Input {...input} placeholder={placeholder}  onScroll={this.handleScroll}
                                            // onChange={event => this.handelOption(event, input)}
                                            type={type} name={name} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }} >
                                            {optionTitle && <option value={0}>{optionTitle}</option>}
                                            {options ?
                                                options.map((element, index) => {

                                                    return (
                                                        <option value={element.value}>{lang === "ar" ? element.title.ar : element.title.en}</option>
                                                    )
                                                }) :
                                                object && object.map((element, index) => {
                                                    if (child && element[child]) {
                                                        let childobj = element[child]
                                                        return (
                                                            <option value={keyId ? childobj[keyId] : JSON.stringify(element)}>{childobj[keyElement]}</option>
                                                        )


                                                    }
                                                    else {
                                                        return (
                                                            <option value={keyId ? element[keyId] : JSON.stringify(element)}>{element[keyElement] ? element[keyElement] : `${element.height.value}-${element.width.value}-${element.diameter.value}`}</option>
                                                        )
                                                    }


                                                })
                                            }
                                        </Input>
                                        :

                                        <Input {...input} placeholder={placeholder} onScroll={this.handleScroll}
                                            type={type} name={name} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }} >
                                            {optionTitle && <option value={0}>{optionTitle}</option>}
                                            {options ?
                                                options.map((element, index) => {
                                                    console.log("it has options!! ")
                                                    return (
                                                        <option value={countryCode ? element.value + ',' + element.countryCode : element.value} test={index}>{lang === "ar" ? element.title.ar : element.title.en}</option>
                                                        // <option value={ element.value + ',' + element.countryCode} test={index}>{lang === "ar" ? element.title.ar : element.title.en}</option>

                                                    )
                                                }) :
                                                object && object.map((element, index) => {
                                                    if (child && element[child]) {
                                                        let childobj = element[child]
                                                        return (
                                                            <option value={keyId ? childobj[keyId] : JSON.stringify(element)}>{childobj[keyElement]}</option>
                                                        )


                                                    }
                                                    else {
                                                       return (
                                                            <option value={keyId ? element[keyId] : JSON.stringify(element)}>{element[keyElement] ? element[keyElement] : `${element.film.name}`}</option>
                                                        )
                                                    }


                                                })
                                            }
                                        </Input>
                                    )}


                                {type === "date"  &&
                                    <Input
                                        {...input}
                                        maxLength={maxLength}
                                        onChange={event => this.InputhandleChange(event, input, inputType)}
                                        onKeyPress={event => this.InputhandleChange(event, input, inputType)}
                                        placeholder={placeholder}
                                        type={'date'}
                                        name={input.name}
                                        value={this.props.localDate ? this.props.localDate : this.state.object}
                                    //  value={input.value ? (this.state.object? this.state.object:input.value) :this.state.object}                                     style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF"}} 
                                    />

                                }
                                {/* Text Input */}
                                {type !== "radio" && type !== "select" && type !== "checkbox" && type !== "file" &&
                                    <Input
                                        {...input}
                                        rows={this.props.rows}
                                        maxLength={maxLength}
                                        onChange={event => this.InputhandleChange(event, input, inputType)}
                                        onKeyPress={event => this.InputhandleChange(event, input, inputType)}
                                        placeholder={placeholder}
                                        type={type}
                                        name={input.name}
                                        //   value={this.props.intializeinput?this.props.intializeinput:this.state.object} 
                                        value={input.value ? (this.state.object ? this.state.object : input.value) : this.state.object} style={{ backgroundColor: this.props.background ? this.props.background : "#FFFFFF" }}
                                    />
                                }
                                {type === "file" &&
                                    <div className="upload mx-3"
                                        style={{ textAlign: 'center' ,width: "100%" }}>
                                        {
                                            uploaded === "dashedBox" ?
                                                this.state.imagePreviewUrl || this.props.userimagepreview ?
                                                    <div>
                                                        {this.props.HintText ?
                                                            <h6>{this.props.HintText[this.props.lang]}</h6>
                                                            : null}
                                                        <ReactImageFallback
                                                            src={

                                                                this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                    :
                                                                    this.props.userimagepreview ?
                                                                        (API_ENDPOINT + this.props.userimagepreview)
                                                                        :
                                                                        user
                                                            }
                                                            fallbackImage={logo}
                                                            initialImage={user}
                                                            alt={`Driver`}
                                                            className={"useravater"} />
                                                    </div>

                                                    :
                                                    <div style={{ width: '150px', height: '150px', border: '1px dashed black ', borderRadius: '20px', textAlign: 'center' }}>
                                                        {
                                                            this.props.HintText ?
                                                                <h5 style={{ textAlign: 'center', marginTop: '30%' }}>{this.props.HintText[this.props.lang]}</h5>
                                                                : null
                                                        }
                                                    </div>
                                                : uploaded === "user" ?

                                                    <ReactImageFallback
                                                        src={

                                                            this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                :
                                                                this.props.userimagepreview ?
                                                                    (API_ENDPOINT + this.props.userimagepreview)
                                                                    :
                                                                    user
                                                        }
                                                        fallbackImage={logo}
                                                        initialImage={user}
                                                        alt={`Driver`}
                                                        className={"useravater"} />
                                                    
                                                    : uploaded === "cinema" ?
                                                    <ReactImageFallback
                                                        src={

                                                            this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                :
                                                                this.props.userimagepreview ?
                                                                    (API_ENDPOINT + this.props.userimagepreview)
                                                                    :
                                                                    cinema
                                                        }
                                                        fallbackImage={cinema}
                                                        initialImage={cinema}
                                                        alt={`Cinema`}
                                                        className={"useravater"} />
                                                        : uploaded === "cinemaAvater" ?
                                                        <ReactImageFallback
                                                            src={
    
                                                                this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                    :
                                                                    this.props.userimagepreview ?
                                                                        (API_ENDPOINT + this.props.userimagepreview)
                                                                        :
                                                                        cinemaHall
                                                            }
                                                            fallbackImage={cinemaHall}
                                                            initialImage={cinemaHall}
                                                            alt={`cinemaHall`}
                                                            style={{width:"200px"}}
                                                            className={"useravater"} />
                                                            : uploaded === "EventAvater" ?
                                                            <ReactImageFallback
                                                                src={
        
                                                                    this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                        :
                                                                        this.props.userimagepreview ?
                                                                            (API_ENDPOINT + this.props.userimagepreview)
                                                                            :
                                                                            eventHall
                                                                }
                                                                fallbackImage={eventHall}
                                                                initialImage={eventHall}
                                                                alt={`eventHall`}
                                                                style={{width:"200px"}}
                                                                className={"useravater"} />    
                                                        : uploaded === "event" ?
                                                        <ReactImageFallback
                                                            src={
    
                                                                this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                    :
                                                                    this.props.userimagepreview ?
                                                                        (API_ENDPOINT + this.props.userimagepreview)
                                                                        :
                                                                        event
                                                            }
                                                            fallbackImage={event}
                                                            initialImage={event}
                                                            alt={`event`}
                                                            className={"useravater"} />
                                                    :uploaded === "film" ?

                                                    <ReactImageFallback
                                                        src={

                                                            this.state.imagePreviewUrl ? (this.state.imagePreviewUrl)
                                                                :
                                                                this.props.userimagepreview ?
                                                                    (API_ENDPOINT + this.props.userimagepreview)
                                                                    :
                                                                    film
                                                        }
                                                        fallbackImage={logo}
                                                        initialImage={film}
                                                        alt={`Film`}
                                                        className={"filmavater"} />
                                                        
                                                    
                                                    :
                                                        uploaded === "object" ?
                                                            this.props.productimagepreview ?
                                                                <div style={{ position: 'relative' }} >
                                                                    {this.props.productimagepreview &&
                                                                        <div className="imgPreview add-imgPreview " style={{ position: 'absolute', top: '0px', left: '26px', zIndex: 999999999 }}>
                                                                            <i onClick={() => this.fn(input, input.name)} className={uploaded === "image" ? "fa fa-window-close close" : "fa fa-window-close"}></i>
                                                                        </div>
                                                                    }
                                                                    <img className="btn-file-input"
                                                                        src={this.props.productimagepreview}
                                                                        style={{ width: "150px", height: "150px" }}
                                                                        alt="avatar" />
                                                                </div>

                                                                :
                                                                (
                                                                    <div>
                                                                        <div style={{ backgroundColor: "#FFFF", margin: "0 auto", textAlign: "center", height: "100px", border: "1px dotted grey" }}>
                                                                            <div style={{ backgroundColor: "#4b7eb0", borderRadius: "50%", width: "31px", margin: "auto", marginTop: "20%" }}>
                                                                                <i className="fa fa-plus" style={{ color: "#FFFF" }} ></i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )

                                                            :
                                                            uploaded === "ticket" ?
                                                                <img className="btn-file-input"
                                                                    style={{ width: "100px" }}
                                                                    src=
                                                                    {
                                                                        this.state.imagePreviewUrl ? (this.state.imagePreviewUrl) :
                                                                            this.props.userimagepreview ?
                                                                                (API_ENDPOINT + this.props.userimagepreview)
                                                                                :
                                                                                ticket
                                                                    }
                                                                    alt="ticket"
                                                                /> :
                                                               
                                                                    uploaded === "avaterproduct" ?

                                                                        <img style={{ width: "100px" }} className="btn-file-input"

                                                                            src=
                                                                            {
                                                                                this.state.imagePreviewUrl ? (this.state.imagePreviewUrl) :
                                                                                    this.props.userimagepreview ?
                                                                                        (API_ENDPOINT + this.props.userimagepreview)
                                                                                        :
                                                                                        avaterproduct
                                                                            }
                                                                            alt="avaterproduct"
                                                                        />


                                                                        :
                                                                        uploaded !== "avatar" ?

                                                                            <img className="btn-file-input uploadImage" style={{ width: "100px" }} src={this.state.imagePreviewUrl ?

                                                                                (this.state.imagePreviewUrl) :
                                                                                this.props.userimagepreview ?
                                                                                    (API_ENDPOINT + this.props.userimagepreview) :
                                                                                    user} alt="avatar" /> &&
                                                                            <div class="OverlayImage" style={{ opacity: 1 }}>
                                                                                <div class="text">Upload Image</div>
                                                                            </div>

                                                                            :
                                                                            <i className="fas fa-cloud-upload-alt" style={{ top: "5px", right: "9px", fontSize: "3rem" }}></i>
                                        }
                                         {this.props.HintText ?
                                                            <h5 style={{color:"#ff5b39",paddingTop:"10px"}}>{this.props.HintText[this.props.lang]}</h5>
                                                            : null}
                                        {/* <div className="ImageUploadContainer">
                                            <div className="overlayImageUpload "><h4>{this.props.lang === "ar" ? "اضف صورة هنا" : "upload image here"}</h4> </div> */}
                                        <input
                                            style={{ cursor: "pointer", opacity: '0', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0' }}
                                            name={input.name}
                                            type={type}
                                            accept={filetype}
                                            // style={"width:150px;"}
                                            onChange={event => this.handleChange(event, input)}
                                            id="upladimg"
                                        />
                                        {/* <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target="upladimg" toggle={this.toolTiptoggle}>
                                            {String.uploadimg}
                                        </Tooltip> */}
                                    </div>

                                }
                               
                                {icone &&
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            {/* <i className={icone}></i> */}
                                            {/* <i className={(loginBool === true && lang==="en" ) ? {icone} +" left_border " : {icone} +" right_border "}></i> */}
                                            {this.props.loginBool &&
                                                <i className={(this.props.loginBool && lang === "en") ? this.props.icone + " left_border " : this.props.icone + " right_border "}></i>
                                            }
                                            {/* <i className={icone + { loginBool === true && lang === 'en' ? ' left_border ' : ' right_border '} }></i> */}

                                        </InputGroupText>
                                    </InputGroupAddon>
                                }
                            </InputGroup >
                            {type === "file" ?
                                <div className="text-center " style={{ marginTop: "10px" }}>
                                    {touched && ((error && <span className="mt-3 erroMSG" style={{
                                        color: "red", fontSize: "0.8rem", position: 'absolute',
                                        bottom: '0',
                                        left: '46%'
                                    }}>
                                        {lang === "en" ? error.en : error.ar}</span>))}
                                </div> :
                                <div className={lang === "en" ? "LeftAlign" : "RightAlign"} style={{ marginTop: "10px" }}>
                                    {touched && ((error && <span className="mt-3 erroMSG" style={{ color: "red", fontSize: "0.8rem" }}> {lang === "en" ? error.en : error.ar}</span>))}
                                </div>
                            }
                        </div>
                    </FormGroup>

                }
                {uploaded !== "user" && uploaded !== "avater" && uploaded !== "ticket" && uploaded !== "avaterid" && uploaded !== "object" && this.state.imagePreviewUrl &&
                    <div className="imgPreview add-imgPreview" style={{
                        position: 'absolute',
                        top: '0',
                        left: '50%',
                    }}>

                        <i onClick={() => this.setState({ imagePreviewUrl: null, file: null })} className={uploaded === "image" ? "fa fa-window-close close" : "fa fa-window-close"}></i>
                    </div>}
            </Col>
        )
    }

}
const mapStateToProps = state => {
    return {
        token: state.userInfo.token,
        language: state.userInfo.language
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        showLoading,
        hideLoading

    }
    , dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(CustomInput)
